export default __webpack_public_path__ + "static/media/Omnitrack_document.49f18486.svg";